<template>
    <div>
        <a-card title="异常分析">
            <div style="margin-bottom:18px;">
                <div>
                    <envSelecter v-model="selectedEnv" style="display:inline-flex;"></envSelecter>
                    <sysSelecter v-model="sleectedSys" style="display:inline-flex;"></sysSelecter>
                    <timeSelecter v-model="selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                    <a-button type="primary" style="margin-left:20px;" @click="handleSubmit">查询</a-button>
                </div>
            </div>
            <a-row :gutter="[16,16]">
                <a-col :span='12'>
                    <echart ref="echartId"></echart>

                </a-col>

                <a-col :span='12'>
                    <epie ref="epieId"></epie>
                </a-col>
            </a-row>
            <a-row :gutter="[16,16]">
                <a-col :span='24'>
                    <etable ref="etableId" :style="{width:tableWidth}"></etable>

                </a-col>

            </a-row>
        </a-card>

    </div>
</template>

<script>
import sysSelecter from '../components/sysSelecter'
import envSelecter from '../components/envSelecter'
import timeSelecter from '../components/timeselecter'


import echart from "../overview/errcountchart"
import epie from "./errorpie"
import etable from "./etable"
export default {
    data(){
        return {
            sleectedSys:'',
            selectedEnv:'',
            selectedTimeRange:'',
            tableWidth:'800px'
        }
    },
    methods:{
        handleSubmit(){
            this.$refs.epieId.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            this.$refs.etableId.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange,1);
            this.$refs.echartId.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    mounted(){
        this.getTableWidth();
        this.handleSubmit()
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);
    },
    components:{
        timeSelecter,
        echart,
        epie,
        etable,
        sysSelecter,
        envSelecter
    }
};
</script>

<style lang="less" scoped>
</style>
<style>

</style>